var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"exportBtn"},[_c('lk-button',{attrs:{"type":_vm.type,"icon":_vm.icon,"loading":_vm.loading},on:{"click":_vm.click}},[(!_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('span',[_vm._v("导出中")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }